<template>
  <div>
    <i v-if="check" class="fa fa-check"></i>
    <i v-else class="fa fa-times"></i>
  </div>
</template>

<script>
  export default {
    name: 'ColumnCheck',
    props: ['row', 'column', 'active'],
    data: () => {
      return {}
    },
    methods: {},
    computed: {
      check: {
        cache: false,
        get: function () {
          if (typeof this.row[this.column] === "boolean") {

            // We have a column Public, instead of Private
            if (this.column === "private") {
              return !this.row[this.column];
            }
            return this.row[this.column];
          } else {
            return this.row[this.column] === this.active
          }
        }
      }
    }
  }
</script>
<style scoped>
  .fa.fa-check {
    color: #05cb19;
  }

  .fa.fa-times {
    color: #d80600;
  }
</style>
